// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import RefinableListWidgetWithExport from '../../../../shared/components/refinable-list-widget/refinable-list-widget-with-export';
import SearchFilters from '../../../../shared/state/search-filters';
import SpaClaimForApproval from '@deere/cps-it.warranty-model-factory/lib/claim-for-approval-summary';
import SpaResult from './spa-result';
import spaClaimsSortOptions from '../../services/spa-claims-sort-options';

const SpaList = props =>
    <div>
        <RefinableListWidgetWithExport
            hasResults={props.hasResults}
            onExport={props.onExport}
            onFilterByChange={props.updateListFilterBy}
            onSortByChange={props.updateListSortBy}
            onSortDirectionChange={props.updateListSortDirection}
            searchFilters={props.spaClaimsSearchFilters}
            sortOptions={spaClaimsSortOptions}
        />
        {props.spaClaims.map((claim, index) =>
            <SpaResult
                claim={claim}
                key={index}
            />
        )}
    </div>;

SpaList.displayName = 'SpaList';
SpaList.propTypes = {
    hasResults: PropTypes.bool.isRequired,
    onExport: PropTypes.func.isRequired,
    spaClaims: PropTypes.arrayOf(PropTypes.instanceOf(SpaClaimForApproval)).isRequired,
    spaClaimsSearchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    updateListFilterBy: PropTypes.func.isRequired,
    updateListSortBy: PropTypes.func.isRequired,
    updateListSortDirection: PropTypes.func.isRequired
};

export default SpaList;



// WEBPACK FOOTER //
// ./src/tabm/wip/components/special-allowance/spa-list.js